export default __webpack_public_path__ + "static/media/email-aux-light.b411a0b5.svg";